import {
  Geometry,
  Project,
  ProjectConfig,
  ProjectStatus,
  ProjectStatusObj,
  RunConfigProto,
  RunStatus,
  RunStatusObj,
  SelectOption,
  TableColDef,
  TyreSet,
  Vehicle,
  Workflow,
  WorkflowTask
} from '../types/types'

export const TeamId = 'TestingTeam'

export const CurrentUserKey = 'CURRENT_USER'
export const AccessTokenKey = 'ACCESS_TOKEN'
export const RescaleTokenKey = 'RESCALE_ACCESS_TOKEN'
export const GMMSRaceTeamKey = 'GMMS_RACE_TEAM_ID'

export const RecentSequenceKey = 'RECENT_SEQUENCE_KEY'
export const RecentGeometryKey = 'RECENT_GEOMETRY_KEY'
export const RecentCarStorageKey = 'RECENT_CAR_STORAGE_KEY'

export const MaxSavedSequence = 10
export const MaxSavedGeometry = 20

export const DefaultPageSize = 10

export const CompactTableBodyClassName = '!p-1'
export const CompactTableHeaderClassName = 'py-1 px-1'

export const DummyWorkflow = new Workflow()
export const DummyWorkflowTask = new WorkflowTask()
export const DummyRunConfig = new RunConfigProto()
export const DummyTyreSet = new TyreSet()
export const DummyVehicle = new Vehicle()
export const DummyProjectConfig = new ProjectConfig()
export const DummyProject = new Project()
DummyProject.raceTeamId = 'geoffsTeam'
DummyProject.status = ProjectStatus.ACTIVE
DummyProject.contributors = []
DummyProject.isBaseline = false

export const DummyGeometry = new Geometry()
DummyGeometry.raceTeamId = TeamId

const DummyGeo2 = new Geometry()
DummyGeo2.raceTeamId = TeamId

export const DummyGeometryList: Geometry[] = []

export const ProjectStatusDef = {
  [ProjectStatus.ACTIVE]: {
    name: 'Active'
  },
  [ProjectStatus.ARCHIVED]: {
    name: 'Archived'
  }
}

export const WorkflowStatusDef = {
  [RunStatus.COMPLETED]: {
    name: 'Completed'
  },
  [RunStatus.CANCELLED]: {
    name: 'Cancelled'
  },
  [RunStatus.WARN_ON_ERROR]: {
    name: 'WarnOnError'
  },
  [RunStatus.CREATED]: {
    name: 'Created'
  },
  [RunStatus.WAITING]: {
    name: 'Waiting'
  },
  [RunStatus.ERROR]: {
    name: 'Error'
  },
  [RunStatus.RUNNING]: {
    name: 'Running'
  },
  [RunStatus.SUBMITTED]: {
    name: 'Submitted'
  },
  [RunStatus.UNSPECIFIED]: {
    name: 'Unspecified'
  },
  [RunStatus.PENDING]: {
    name: 'Pending'
  }
}

export const ProjectStatusList: ProjectStatusObj[] = [
  {
    value: ProjectStatus.ACTIVE,
    name: ProjectStatusDef[ProjectStatus.ACTIVE].name
  },
  {
    value: ProjectStatus.ARCHIVED,
    name: ProjectStatusDef[ProjectStatus.ARCHIVED].name
  }
]

export const SubmissionStatusList: RunStatusObj[] = [
  {
    value: RunStatus.CREATED,
    name: WorkflowStatusDef[RunStatus.CREATED].name
  },
  {
    value: RunStatus.SUBMITTED,
    name: WorkflowStatusDef[RunStatus.SUBMITTED].name
  },
  {
    value: RunStatus.PENDING,
    name: WorkflowStatusDef[RunStatus.PENDING].name
  },
  {
    value: RunStatus.WAITING,
    name: WorkflowStatusDef[RunStatus.WAITING].name
  },
  {
    value: RunStatus.RUNNING,
    name: WorkflowStatusDef[RunStatus.RUNNING].name
  },
  {
    value: RunStatus.ERROR,
    name: WorkflowStatusDef[RunStatus.ERROR].name
  },
  {
    value: RunStatus.WARN_ON_ERROR,
    name: WorkflowStatusDef[RunStatus.WARN_ON_ERROR].name
  },
  {
    value: RunStatus.COMPLETED,
    name: WorkflowStatusDef[RunStatus.COMPLETED].name
  },
  {
    value: RunStatus.CANCELLED,
    name: WorkflowStatusDef[RunStatus.CANCELLED].name
  }
]

export const TaskTypes: SelectOption[] = [
  {
    value: 'platform',
    label: 'Platform'
  },
  {
    value: 'rescale',
    label: 'Rescale'
  }
]

export const Areas: SelectOption[] = [
  {
    value: 'Rear Wing',
    label: 'Rear Wing'
  },
  {
    value: 'Front Wing',
    label: 'Front Wing'
  },
  {
    value: 'Rear Corner',
    label: 'Rear Corner'
  },
  {
    value: 'Floor Fillet',
    label: 'Floor Fillet'
  },
  {
    value: 'Front Corner',
    label: 'Front Corner'
  },
  {
    value: 'Rear Bodywork',
    label: 'Rear Bodywork'
  },
  {
    value: 'Floor Bodywork',
    label: 'Floor Bodywork'
  }
]

export const NASCARTeams: string[] = [
  'NASCAR-Cup',
  'NASCAR-Cup-28',
  'NASCAR-NBS',
  '26-sub',
  'NASCAR-Truck',
  'NBS-HFT',
  'testing-team-dev'
]

export const NASCAR28Teams: string[] = ['NASCAR-Cup-28', 'testing-team-dev']

export const NASCAR28Areas: SelectOption[] = [
  {
    value: 'BL',
    label: 'Baseline'
  },
  {
    value: 'FF',
    label: 'Front Fascia'
  },
  {
    value: 'FQ',
    label: 'Front Quarters'
  },
  {
    value: 'HD',
    label: 'Hood'
  },
  {
    value: 'HE',
    label: 'Hood Exits'
  },
  {
    value: 'DR',
    label: 'Doors'
  },
  {
    value: 'RQ',
    label: 'Rear Quarters'
  },
  {
    value: 'RF',
    label: 'Rear Fascia'
  },
  {
    value: 'MX',
    label: 'Methodology'
  },
  {
    value: 'MC',
    label: 'MultiCar'
  },
  {
    value: 'ML',
    label: 'Machine Learning'
  },
  {
    value: 'CN',
    label: 'Correlation'
  }
]

export const IndyCarTeams: string[] = ['indycar', 'IndyCar-28', 'lmdh', 'testing-team']

export const IndyCarAreas: SelectOption[] = [
  {
    value: 'BD',
    label: 'Body'
  },
  {
    value: 'CP',
    label: 'Cockpit'
  },
  {
    value: 'EB',
    label: 'Engine Bay'
  },
  {
    value: 'EX',
    label: 'Exhaust'
  },
  {
    value: 'FW',
    label: 'Front Wing'
  },
  {
    value: 'FLB',
    label: 'Floor Bottom'
  },
  {
    value: 'FLT',
    label: 'Floor Top'
  },
  {
    value: 'IN',
    label: 'Intake'
  },
  {
    value: 'RW',
    label: 'Rear Wing'
  },
  {
    value: 'EC',
    label: 'Engine Cooling'
  },
  {
    value: 'BL',
    label: 'Baseline'
  },
  {
    value: 'ML',
    label: 'Machine Learning'
  },
  {
    value: 'MX',
    label: 'Methodology'
  },
  {
    value: 'MC',
    label: 'MultiCar'
  },
  {
    value: 'CN',
    label: 'Correlation'
  },
  {
    value: 'FS',
    label: 'Front Suspension'
  },
  {
    value: 'RS',
    label: 'Rear Suspension'
  }
]

export const NASCARAreas: SelectOption[] = [
  {
    value: 'Baseline',
    label: 'Baseline'
  },
  {
    value: 'Bodywork',
    label: 'Bodywork'
  },
  {
    value: 'Underfloor',
    label: 'Underfloor'
  },
  {
    value: 'Front Suspension',
    label: 'Front Suspension'
  },
  {
    value: 'Rear Suspension',
    label: 'Rear Suspension'
  },
  {
    value: 'Engine Bay',
    label: 'Engine Bay'
  },
  {
    value: 'Cockpit',
    label: 'Cockpit'
  },
  {
    value: 'Trunk Area',
    label: 'Trunk Area'
  },
  {
    value: 'Methodology',
    label: 'Methodology'
  },
  {
    value: 'MultiCar',
    label: 'MultiCar'
  },
  {
    value: 'Machine Learning',
    label: 'Machine Learning'
  },
  {
    value: 'Correlation',
    label: 'Correlation'
  }
]

export const VehicleStateColDefs: TableColDef[] = [
  {
    title: 'VS',
    field: 'vehicleStateId'
  },
  {
    title: 'AHF',
    field: 'ahf'
  },
  {
    title: 'AHR',
    field: 'ahr'
  },
  {
    title: 'Roll',
    field: 'roll'
  },
  {
    title: 'Yaw',
    field: 'yaw'
  },
  {
    title: 'Cnr Rad',
    field: 'cornerRad'
  },
  {
    title: 'Steer',
    field: 'steer'
  },
  {
    title: 'Speed',
    field: 'speed'
  },
  {
    title: 'FF',
    field: 'ff'
  },
  {
    title: 'RF',
    field: 'rf'
  },
  {
    title: 'RR',
    field: 'rr'
  },
  {
    title: 'Exh',
    field: 'exh'
  },
  {
    title: 'DRS%',
    field: 'drs'
  }
]

export const VehicleStateEditColDefs: TableColDef[] = [
  {
    title: 'AHF',
    field: 'ahf'
  },
  {
    title: 'AHR',
    field: 'ahr'
  },
  {
    title: 'Roll',
    field: 'roll'
  },
  {
    title: 'Yaw',
    field: 'yaw'
  },
  {
    title: 'Cnr Rad',
    field: 'cornerRad'
  },
  {
    title: 'Steer',
    field: 'steer'
  },
  {
    title: 'Speed',
    field: 'speed'
  },
  {
    title: 'FF',
    field: 'ff'
  },
  {
    title: 'RF',
    field: 'rf'
  },
  {
    title: 'RR',
    field: 'rr'
  },
  {
    title: 'Exh',
    field: 'exh'
  },
  {
    title: 'DRS%',
    field: 'drs'
  }
]

export const SimulationTypes: SelectOption[] = [
  {
    value: 'half',
    label: 'Half Car'
  },
  {
    value: 'full',
    label: 'Full Car'
  }
]

export const VSTableColumns = [
  {
    header: 'Name',
    field: 'name',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'VS',
    field: 'vehicleStateId',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'AHF',
    field: 'ahf',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'AHR',
    field: 'ahr',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Steer',
    field: 'steer',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Roll',
    field: 'roll',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Yaw',
    field: 'yaw',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Cnr Rad',
    field: 'cornerRad',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'FF',
    field: 'ff',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'RF',
    field: 'rf',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Speed',
    field: 'speed',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'RR',
    field: 'rr',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'Exh',
    field: 'exh',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  },
  {
    header: 'DRS%',
    field: 'drs',
    headerClassName: CompactTableHeaderClassName,
    bodyClassName: CompactTableBodyClassName
  }
]

export const VS_STATUS_ACTIVE = 'Active'
export const VS_STATUS_DELETED = 'Deleted'

export const STATUS_TEST = 'Test'
export const STATUS_RELEASE = 'Release'

const theYear = new Date().getFullYear()
export const carList = [theYear, theYear + 1]

export const DataStatusList: SelectOption[] = [
  {
    value: STATUS_TEST,
    label: STATUS_TEST
  },
  {
    value: STATUS_RELEASE,
    label: STATUS_RELEASE
  }
]

export const METHODOLOGY_STATUS_DRAFT = 'Draft'
export const METHODOLOGY_STATUS_RELEASED = 'Released'
export const METHODOLOGY_STATUS_ARCHIVED = 'Archived'

export const MethodologyStatusList: SelectOption[] = [
  {
    value: METHODOLOGY_STATUS_DRAFT,
    label: METHODOLOGY_STATUS_DRAFT
  },
  {
    value: METHODOLOGY_STATUS_RELEASED,
    label: METHODOLOGY_STATUS_RELEASED
  },
  {
    value: METHODOLOGY_STATUS_ARCHIVED,
    label: METHODOLOGY_STATUS_ARCHIVED
  }
]

export const methodTemplate = {
  id: '',
  desc: '',
  created_by: '',
  updated_on: '',
  created_on: '',
  updated_by: '',
  dictionary: {
    name: '',
    domain: {
      WT: {
        code: {
          path: '',
          setup_path: ''
        },
        template: {
          path: ''
        }
      }
    },
    star_version_server: '',
    star_version_rescale: ''
  },
  local_id: '00007',
  released: true
}

export const tyreSetTemplate = {
  id: '',
  desc: '',
  created_by: '',
  updated_on: '',
  created_on: '',
  updated_by: '',
  dictionary: {
    name: 'Set_v001',
    states: {
      Standard: {
        fl: {
          cp_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ],
          axis_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        },
        fr: {
          cp_cs: [
            [0, 0, 0],
            [1, 0, 0],
            [0, -1, 0]
          ],
          axis_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        },
        rl: {
          cp_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ],
          axis_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        },
        rr: {
          cp_cs: [
            [0, 0, 0],
            [1, 0, 0],
            [0, 0, 0]
          ],
          axis_cs: [
            [0, 0, 0],
            [0, 0, 0],
            [0, 0, 0]
          ]
        },
        cad: '24S40-01-0011, 24S40-02-0013'
      }
    },
    description: ''
  },
  local_id: '',
  released: true
}

export const projectConfigTemplate = {
  id: '',
  desc: '',
  created_by: '',
  updated_on: '',
  created_on: '',
  updated_by: '',
  dictionary: {
    headline: {
      Cd: {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'CD Monitor'
      },
      Cl: {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'CL Monitor'
      },
      Cs: {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'CS Monitor'
      },
      ClF: {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'CLf Monitor'
      },
      ClR: {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'CLr Monitor'
      },
      FAB: {
        dp: 1,
        gain: 'NA',
        invert: 'false',
        monitor: 'derived'
      },
      'FW Cd': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'FW_CD Monitor'
      },
      'FW Cl': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'FW_CL Monitor'
      },
      'RW Cd': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'RW_CD Monitor'
      },
      'RW Cl': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'RW_CL Monitor'
      },
      'Cd Body': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'Sprung_CD Monitor'
      },
      'Cl Body': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'Sprung_CL Monitor'
      },
      'Cs Body': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'Sprung_CS Monitor'
      },
      'ClF Body': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'Sprung_CLf Monitor'
      },
      'ClR Body': {
        dp: 3,
        gain: '-',
        invert: 'false',
        monitor: 'Sprung_CLr Monitor'
      },
      'FAB Body': {
        dp: 1,
        gain: 'NA',
        invert: 'false',
        monitor: 'derived'
      },
      'LH Rad (kg/s)': {
        dp: 2,
        gain: '+',
        invert: 'true',
        monitor: 'RAD1_mdot Monitor (kg/s)'
      },
      'RH Rad (kg/s)': {
        dp: 2,
        gain: '+',
        invert: 'true',
        monitor: 'RAD2_mdot Monitor (kg/s)'
      },
      'Ctr Rad (kg/s)': {
        dp: 2,
        gain: '+',
        invert: 'true',
        monitor: 'RAD3_mdot Monitor (kg/s)'
      }
    }
  },
  local_id: '',
  released: true
}

export const cfdSequenceTemplate = {
  id: '',
  desc: '',
  created_by: '',
  updated_on: '',
  created_on: '',
  updated_by: '',
  dictionary: {
    name: '',
    states: {
      EoS: {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      HSA: {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 3,
        radius: 0,
        exhaust: 0.0
      },
      MSA: {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 6,
        radius: 0,
        exhaust: 0.0
      },
      EXIT: {
        FRH: 30,
        RRH: 45,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      LSA0Y: {
        FRH: 30,
        RRH: 60,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      'LSA+3Y': {
        FRH: 0,
        RRH: 0,
        yaw: 3,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      'LSA+6Y': {
        FRH: 0,
        RRH: 0,
        yaw: 6,
        roll: 0.0,
        speed: 0,
        steer: 8,
        radius: 0,
        exhaust: 0.0
      },
      'LSA+9Y': {
        FRH: 30,
        RRH: 60,
        yaw: 9,
        roll: 0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      'LSA-3Y': {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      'LSA-6Y': {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      'LSA-9Y': {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      },
      BRAKING: {
        FRH: 0,
        RRH: 0,
        yaw: 0,
        roll: 0.0,
        speed: 0,
        steer: 0,
        radius: 0,
        exhaust: 0.0
      }
    }
  },
  local_id: '',
  released: true
}

export const workflowTemplate = {
  id: '',
  desc: '',
  created_by: '',
  updated_on: '',
  created_on: '',
  updated_by: ''
}

export const simpleRunProjection = encodeURIComponent(
  JSON.stringify({
    _id: 1,
    name: 1,
    shortName: 1
  })
)

export const basicRunReferenceProjection = encodeURIComponent(
  JSON.stringify({
    _id: 1,
    name: 1,
    'submissionRunGroups.workflowRunGroups.systemRunId': 1,
    'submissionRunGroups.workflowRunGroups.runGroupCase.selectedAttitudeState': 1
  })
)

export const starCCMMacroSteps = [
  { name: 'Import', value: 'import' },
  { name: 'Precheck', value: 'precheck' },
  { name: 'Clear Solution History', value: 'clearSolutionHistory' },
  { name: 'Drafting Setup', value: 'drafting' },
  { name: 'Mesh', value: 'mesh' },
  { name: 'Run', value: 'run' },
  { name: 'Removal Loop', value: 'removal_loop' },
  { name: 'Post Processing', value: 'postpro' }
]

export const UploadTypes = {
  RIDE_HEIGHT_FILE: 'RIDE_HEIGHT_FILE',
  GEOMETRY_CHANGE_FILE: 'GEOMETRY_CHANGE_FILE',
  STARCCM_SIM_FILE: 'STARCCM_SIM_FILE',
  STARCCM_MACRO_FILE: 'STARCCM_MACRO_FILE',
  PRESSURE_TAP_FILE: 'PRESSURE_TAP_FILE',
  OVERRIDE_STARCCM_TEMPLATE_FILE: 'OVERRIDE_STARCCM_TEMPLATE_FILE',
  CASE_SIM_TEMPLATE_FILE: 'CASE_SIM_TEMPLATE_FILE'
}

export const UploadStatus = {
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED'
}

export const ComplianceTeamOptions: SelectOption[] = [
  { label: 'Hendrick', value: 'HMS' },
  { label: 'Trackhouse', value: 'TRK' },
  { label: 'RCR', value: 'RCR' },
  { label: 'Spire', value: 'SPR' },
  { label: 'HYAK', value: 'HYK' },
  { label: 'Haas Factory Team', value: 'HFT' },
  { label: 'GM', value: 'GM' }
]

export const ComplianceDescOptions: SelectOption[] = [
  { label: 'Component Change', value: 'Component Change' },
  { label: 'Baseline', value: 'Baseline' },
  { label: 'Mapping', value: 'Mapping' },
  { label: 'Drafting', value: 'Drafting' },
  { label: 'Methodology', value: 'Methodology' }
]

export const TREE_LEVEL_PROJECT = 'project'
export const TREE_LEVEL_RUN = 'run'
export const TREE_LEVEL_CASE = 'case'
export const KEY_DELIMITER = '::'
export const REF_GM_ID_2ND = 'ref_gm_id_2nd'

let sortNumber = 3

const fixedFormat = (digits: number) => (value: number) => value.toFixed(digits)
const exponentialFormat = (digits: number) => (value: number) => value.toExponential(digits)

// Compact builder for the solver-monitor columns, which all share the same
// case-level-only rendering and differ only in label, width and precision.
const createMonitorField = (
  headerName: string,
  field: string,
  width: number,
  format: (value: number) => string
) => ({
  headerName,
  field,
  sortNumber: sortNumber++,
  width,
  resizable: true,
  plottable: true,
  formatter: (value: number, level: string) => (level === TREE_LEVEL_CASE ? format(value) : '')
})

export const AvailableFieldsForHeadlineData = {
  gm_id: {
    headerName: 'Case',
    field: 'gm_id',
    width: 60,
    resizable: true,
    plottable: false,
    sortNumber: sortNumber++,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value
      }
      return ''
    }
  },
  ref_gm_id: {
    headerName: 'Ref',
    field: 'ref_gm_id',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: false,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value ? value : ''
      }
      return ''
    }
  },
  [REF_GM_ID_2ND]: {
    headerName: 'Ref 2',
    field: REF_GM_ID_2ND,
    sortNumber: sortNumber++,
    width: 70,
    resizable: true,
    plottable: false,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE || level === TREE_LEVEL_RUN) {
        return value ? value : ''
      }
      return ''
    }
  },
  end_time: {
    headerName: 'Completed Date',
    field: 'end_time',
    // Always render as the last column
    sortNumber: Number.MAX_SAFE_INTEGER,
    width: 150,
    resizable: true,
    plottable: false,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE || level === TREE_LEVEL_RUN) {
        return value ? new Date(value).toLocaleString() : ''
      }
      return ''
    }
  },
  ahf: {
    headerName: 'AHF',
    field: 'ahf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  ahr: {
    headerName: 'AHR',
    field: 'ahr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  yaw: {
    headerName: 'YAW',
    field: 'yaw',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  steer: {
    headerName: 'STR',
    field: 'steer',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  speed: {
    headerName: 'MPH',
    field: 'speed',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(1)
      }
      return ''
    }
  },
  delta_cd: {
    headerName: 'ΔCD',
    field: 'delta_cd',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_cl: {
    headerName: 'ΔCL',
    field: 'delta_cl',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_clf: {
    headerName: 'ΔCLF',
    field: 'delta_clf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_clr: {
    headerName: 'ΔCLR',
    field: 'delta_clr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_cs: {
    headerName: 'ΔCS',
    field: 'delta_cs',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_csf: {
    headerName: 'ΔCSF',
    field: 'delta_csf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_csr: {
    headerName: 'ΔCSR',
    field: 'delta_csr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  delta_pct_clf: {
    headerName: 'Δ%CLF',
    field: 'delta_pct_clf',
    sortNumber: sortNumber++,
    width: 70,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2) + '%'
    }
  },
  delta_vr: {
    headerName: 'Δ Rad VR',
    field: 'delta_vr',
    sortNumber: sortNumber++,
    width: 70,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  cd: {
    headerName: 'CD',
    field: 'cd',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  cl: {
    headerName: 'CL',
    field: 'cl',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  clf: {
    headerName: 'CLF',
    field: 'clf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  clr: {
    headerName: 'CLR',
    field: 'clr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  cs: {
    headerName: 'CS',
    field: 'cs',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  csf: {
    headerName: 'CSF',
    field: 'csf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  csr: {
    headerName: 'CSR',
    field: 'csr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  pct_clf: {
    headerName: '%CLF',
    field: 'pct_clf',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  vr: {
    headerName: 'Rad VR',
    field: 'vr',
    sortNumber: sortNumber++,
    width: 60,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(3)
    }
  },
  LF_Heat_Transfer_Monitor_W: {
    headerName: 'LF Heat Transfer (W)',
    field: 'LF_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  RF_Heat_Transfer_Monitor_W: {
    headerName: 'RF Heat Transfer (W)',
    field: 'RF_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  LR_Heat_Transfer_Monitor_W: {
    headerName: 'LR Heat Transfer (W)',
    field: 'LR_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  RR_Heat_Transfer_Monitor_W: {
    headerName: 'RR Heat Transfer (W)',
    field: 'RR_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  FLUID_HEAT_TRANSFER_ROTOR_TOTAL_Monitor_kW: {
    headerName: 'Rotor Heat Transfer (kW)',
    field: 'FLUID_HEAT_TRANSFER_ROTOR_TOTAL_Monitor_kW',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  FLUID_HEAT_TRANSFER_CALIPER_Monitor_kW: {
    headerName: 'Caliper Heat Transfer (kW)',
    field: 'FLUID_HEAT_TRANSFER_CALIPER_Monitor_kW',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  FLUID_HEAT_TRANSFER_PADS_TOTAL_Monitor_kW: {
    headerName: 'Pads Heat Transfer (kW)',
    field: 'FLUID_HEAT_TRANSFER_PADS_TOTAL_Monitor_kW',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  FLUID_HEAT_TRANSFER_PISTONS_TOTAL_Monitor_kW: {
    headerName: 'Pistons Heat Transfer (kW)',
    field: 'FLUID_HEAT_TRANSFER_PISTONS_TOTAL_Monitor_kW',
    sortNumber: sortNumber++,
    width: 130,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  FLUID_HEAT_TRANSFER_INLET_OUTLET_Monitor_W: {
    headerName: 'Net Fluid Heat Transfer (W)',
    field: 'FLUID_HEAT_TRANSFER_INLET_OUTLET_Monitor_W',
    sortNumber: sortNumber++,
    width: 140,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  FLUID_HEAT_TRANSFER_VANE_Monitor_kW: {
    headerName: 'Vane Heat Transfer (kW)',
    field: 'FLUID_HEAT_TRANSFER_VANE_Monitor_kW',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  Caliper_HTC_Monitor_W_m_2_K: {
    headerName: 'Caliper HTC',
    field: 'Caliper_HTC_Monitor_W_m_2_K',
    sortNumber: sortNumber++,
    width: 110,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  Rotor_Total_Monitor_W_m_2_K: {
    headerName: 'Rotor HTC',
    field: 'Rotor_Total_Monitor_W_m_2_K',
    sortNumber: sortNumber++,
    width: 110,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  Duct_INLET_OUTLET_MASS_FLOW_Monitor_g_s: {
    headerName: 'Duct Flow (g/s)',
    field: 'Duct_INLET_OUTLET_MASS_FLOW_Monitor_g_s',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(2)
      }
      return ''
    }
  },
  Mass_Flow_Global_Inlet_Monitor_kg_s: {
    headerName: 'Inlet Flow (kg/s)',
    field: 'Mass_Flow_Global_Inlet_Monitor_kg_s',
    sortNumber: sortNumber++,
    width: 130,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Mass_Flow_Global_Outlet_Monitor_kg_s: {
    headerName: 'Outlet Flow (kg/s)',
    field: 'Mass_Flow_Global_Outlet_Monitor_kg_s',
    sortNumber: sortNumber++,
    width: 130,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Cab_Pressure_Monitor_Maximum_of_Pressure_Coefficient: {
    headerName: 'Cab Cp',
    field: 'Cab_Pressure_Monitor_Maximum_of_Pressure_Coefficient',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Engine_Bay_Pressure_Monitor: {
    headerName: 'Engine Bay P',
    field: 'Engine_Bay_Pressure_Monitor',
    sortNumber: sortNumber++,
    width: 110,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Trunk_Pressure_Monitor: {
    headerName: 'Trunk P',
    field: 'Trunk_Pressure_Monitor',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  FW_CD_Monitor: {
    headerName: 'FW CD',
    field: 'FW_CD_Monitor',
    sortNumber: sortNumber++,
    width: 80,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  FW_CL_Monitor: {
    headerName: 'FW CL',
    field: 'FW_CL_Monitor',
    sortNumber: sortNumber++,
    width: 80,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  RW_CD_Monitor: {
    headerName: 'RW CD',
    field: 'RW_CD_Monitor',
    sortNumber: sortNumber++,
    width: 80,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  RW_CL_Monitor: {
    headerName: 'RW CL',
    field: 'RW_CL_Monitor',
    sortNumber: sortNumber++,
    width: 80,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Floor_CL_Monitor: {
    headerName: 'Floor CL',
    field: 'Floor_CL_Monitor',
    sortNumber: sortNumber++,
    width: 90,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  Domain_HT_Balance_Monitor_kW: {
    headerName: 'Domain HT (kW)',
    field: 'Domain_HT_Balance_Monitor_kW',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(2)
    }
  },
  Duct_MAX_TEMP_MONITOR_Monitor_K: {
    headerName: 'Duct Max T (K)',
    field: 'Duct_MAX_TEMP_MONITOR_Monitor_K',
    sortNumber: sortNumber++,
    width: 120,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return value.toFixed(1)
    }
  },
  LS_Inlet_CpT_Monitor: {
    headerName: 'LS Inlet CpT',
    field: 'LS_Inlet_CpT_Monitor',
    sortNumber: sortNumber++,
    width: 110,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  RS_Inlet_CpT_Monitor: {
    headerName: 'RS Inlet CpT',
    field: 'RS_Inlet_CpT_Monitor',
    sortNumber: sortNumber++,
    width: 110,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_CASE) {
        return value.toFixed(3)
      }
      return ''
    }
  },
  pct_change_LF_Heat_Transfer_Monitor_W: {
    headerName: 'LF Heat Transfer (%Δ)',
    field: 'pct_change_LF_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 140,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return `${value.toFixed(1)}%`
    }
  },
  pct_change_RF_Heat_Transfer_Monitor_W: {
    headerName: 'RF Heat Transfer (%Δ)',
    field: 'pct_change_RF_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 140,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return `${value.toFixed(1)}%`
    }
  },
  pct_change_LR_Heat_Transfer_Monitor_W: {
    headerName: 'LR Heat Transfer (%Δ)',
    field: 'pct_change_LR_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 140,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return `${value.toFixed(1)}%`
    }
  },
  pct_change_RR_Heat_Transfer_Monitor_W: {
    headerName: 'RR Heat Transfer (%Δ)',
    field: 'pct_change_RR_Heat_Transfer_Monitor_W',
    sortNumber: sortNumber++,
    width: 140,
    resizable: true,
    plottable: true,
    formatter: (value, level) => {
      if (level === TREE_LEVEL_PROJECT) {
        return ''
      }
      return `${value.toFixed(1)}%`
    }
  },
  // Convergence / DES monitors (averaged over each case's own top_N window)
  Convergence_Criteria_Monitor: createMonitorField(
    'Convergence Criteria',
    'Convergence_Criteria_Monitor',
    140,
    fixedFormat(5)
  ),
  Primary_Mean_CD_Monitor: createMonitorField(
    'Primary Mean CD',
    'Primary_Mean_CD_Monitor',
    130,
    fixedFormat(4)
  ),
  Primary_Mean_CLf_Monitor: createMonitorField(
    'Primary Mean CLf',
    'Primary_Mean_CLf_Monitor',
    130,
    fixedFormat(4)
  ),
  Primary_Mean_CLr_Monitor: createMonitorField(
    'Primary Mean CLr',
    'Primary_Mean_CLr_Monitor',
    130,
    fixedFormat(4)
  ),
  Primary_Mean_Variance_Mean_CD_Monitor: createMonitorField(
    'Primary Mean Var Mean CD',
    'Primary_Mean_Variance_Mean_CD_Monitor',
    180,
    fixedFormat(6)
  ),
  Primary_Mean_Variance_Mean_CLf_Monitor: createMonitorField(
    'Primary Mean Var Mean CLf',
    'Primary_Mean_Variance_Mean_CLf_Monitor',
    180,
    fixedFormat(6)
  ),
  Primary_Mean_Variance_Mean_CLr_Monitor: createMonitorField(
    'Primary Mean Var Mean CLr',
    'Primary_Mean_Variance_Mean_CLr_Monitor',
    180,
    fixedFormat(6)
  ),
  Primary_Variance_Mean_CD_Monitor: createMonitorField(
    'Primary Var Mean CD',
    'Primary_Variance_Mean_CD_Monitor',
    160,
    fixedFormat(6)
  ),
  Primary_Variance_Mean_CLf_Monitor: createMonitorField(
    'Primary Var Mean CLf',
    'Primary_Variance_Mean_CLf_Monitor',
    160,
    fixedFormat(6)
  ),
  Primary_Variance_Mean_CLr_Monitor: createMonitorField(
    'Primary Var Mean CLr',
    'Primary_Variance_Mean_CLr_Monitor',
    160,
    fixedFormat(6)
  ),
  Secondary_Mean_CD_Monitor: createMonitorField(
    'Secondary Mean CD',
    'Secondary_Mean_CD_Monitor',
    140,
    fixedFormat(4)
  ),
  Secondary_Mean_CLf_Monitor: createMonitorField(
    'Secondary Mean CLf',
    'Secondary_Mean_CLf_Monitor',
    140,
    fixedFormat(4)
  ),
  Secondary_Mean_CLr_Monitor: createMonitorField(
    'Secondary Mean CLr',
    'Secondary_Mean_CLr_Monitor',
    140,
    fixedFormat(4)
  ),
  Secondary_Mean_Variance_Mean_CD_Monitor: createMonitorField(
    'Secondary Mean Var Mean CD',
    'Secondary_Mean_Variance_Mean_CD_Monitor',
    190,
    fixedFormat(6)
  ),
  Secondary_Mean_Variance_Mean_CLf_Monitor: createMonitorField(
    'Secondary Mean Var Mean CLf',
    'Secondary_Mean_Variance_Mean_CLf_Monitor',
    190,
    fixedFormat(6)
  ),
  Secondary_Mean_Variance_Mean_CLr_Monitor: createMonitorField(
    'Secondary Mean Var Mean CLr',
    'Secondary_Mean_Variance_Mean_CLr_Monitor',
    190,
    fixedFormat(6)
  ),
  Secondary_Variance_Mean_CD_Monitor: createMonitorField(
    'Secondary Var Mean CD',
    'Secondary_Variance_Mean_CD_Monitor',
    170,
    fixedFormat(6)
  ),
  Secondary_Variance_Mean_CLf_Monitor: createMonitorField(
    'Secondary Var Mean CLf',
    'Secondary_Variance_Mean_CLf_Monitor',
    170,
    fixedFormat(6)
  ),
  Secondary_Variance_Mean_CLr_Monitor: createMonitorField(
    'Secondary Var Mean CLr',
    'Secondary_Variance_Mean_CLr_Monitor',
    170,
    fixedFormat(6)
  ),
  // Solver time
  Total_Solver_CPU_Time_Monitor_hr: createMonitorField(
    'Solver CPU Time (hr)',
    'Total_Solver_CPU_Time_Monitor_hr',
    140,
    fixedFormat(2)
  ),
  Total_Solver_Elapsed_Time_Monitor_hr: createMonitorField(
    'Solver Elapsed Time (hr)',
    'Total_Solver_Elapsed_Time_Monitor_hr',
    150,
    fixedFormat(2)
  ),
  // Residuals / diagnostics
  AMG_Cycles_Monitor_AMG_Cycles: createMonitorField(
    'AMG Cycles',
    'AMG_Cycles_Monitor_AMG_Cycles',
    100,
    fixedFormat(0)
  ),
  CFL_Number_Monitor_CFL_Number: createMonitorField(
    'CFL Number',
    'CFL_Number_Monitor_CFL_Number',
    100,
    fixedFormat(2)
  ),
  Continuity_Continuity: createMonitorField(
    'Continuity',
    'Continuity_Continuity',
    110,
    exponentialFormat(3)
  ),
  PerF_Monitor_Expression: createMonitorField(
    'PerF',
    'PerF_Monitor_Expression',
    90,
    fixedFormat(4)
  ),
  Sdr_Sdr: createMonitorField('Sdr', 'Sdr_Sdr', 110, exponentialFormat(3)),
  Tke_Tke: createMonitorField('Tke', 'Tke_Tke', 110, exponentialFormat(3)),
  VMax_Monitor_Maximum_of_Velocity_Magnitude_mph: createMonitorField(
    'VMax (mph)',
    'VMax_Monitor_Maximum_of_Velocity_Magnitude_mph',
    110,
    fixedFormat(1)
  ),
  X_momentum_X_momentum: createMonitorField(
    'X-momentum',
    'X_momentum_X_momentum',
    110,
    exponentialFormat(3)
  ),
  Y_momentum_Y_momentum: createMonitorField(
    'Y-momentum',
    'Y_momentum_Y_momentum',
    110,
    exponentialFormat(3)
  ),
  Z_momentum_Z_momentum: createMonitorField(
    'Z-momentum',
    'Z_momentum_Z_momentum',
    110,
    exponentialFormat(3)
  ),
  // Underwing component forces
  CD_underwing_Monitor: createMonitorField(
    'Underwing CD',
    'CD_underwing_Monitor',
    110,
    fixedFormat(3)
  ),
  CL_underwing_Monitor: createMonitorField(
    'Underwing CL',
    'CL_underwing_Monitor',
    110,
    fixedFormat(3)
  ),
  CLf_underwing_Monitor: createMonitorField(
    'Underwing CLf',
    'CLf_underwing_Monitor',
    110,
    fixedFormat(3)
  ),
  CLr_underwing_Monitor: createMonitorField(
    'Underwing CLr',
    'CLr_underwing_Monitor',
    110,
    fixedFormat(3)
  )
}

export const InputFields = ['ahf', 'ahr', 'yaw', 'steer', 'speed']

export const VariableFields = [
  'delta_cd',
  'delta_cl',
  'delta_clf',
  'delta_clr',
  'delta_cs',
  'delta_csf',
  'delta_csr',
  'delta_pct_clf',
  'cd',
  'cl',
  'clf',
  'clr',
  'cs',
  'csf',
  'csr',
  'pct_clf'
]

export const CUP28States = [
  '4_SubDrag',
  '4_SubLiftDrag',
  '4_SubLiftSide1',
  '4_SubLiftSide2',
  '4_SubLiftSide3'
]

export const NascarCupTeamId = 'NASCAR-Cup'
